import ButtonSprite from '../components/ButtonSprite';
import translate from '../components/LanguageManager';
import BaseScene from './BaseScene';
import { globals } from '../globals';

export default class Preload extends BaseScene {
    constructor() {
        super({ key: 'Preload' });
    }

    public preload(): void {
        this.load.setPath('./assets/');

        // General
        this.load.image(
            'guide',
            globals.gameMode === 'mobile' ? '540x960-guide.png' : '1280x960-guide.png'
        );

        // Buttons
        this.load.spritesheet('button_replay', './images/button_replay.png', {frameWidth: 94, frameHeight: 94});
        this.load.spritesheet('button_back', './images/button_back.png', {frameWidth: 94, frameHeight: 94});
        this.load.spritesheet('button_next', './images/button_next.png', {frameWidth: 94, frameHeight: 94});
        this.load.spritesheet('button_menu', './images/button_menu.png', {frameWidth: 94, frameHeight: 94});
        this.load.spritesheet('button_pause_green', './images/button_pause_green.png', {frameWidth: 128, frameHeight: 128});
        this.load.spritesheet('button_red_green', './images/button_red_green.png', {frameWidth: 118, frameHeight: 111});
        this.load.image('slide_button_horizontal_box', 'images/slide_button_horizontal_box.png');
        this.load.image('slide_button_horizontal_bar', 'images/slide_button_horizontal_bar.jpg');
        this.load.image('slide_button_vertical_box', 'images/slide_button_vertical_box.png');
        this.load.image('slide_button_vertical_bar', 'images/slide_button_vertical_bar.jpg');
        this.load.image('slide_button_selector', 'images/slide_button_selector.png');
        this.load.image('slide_button_selector_attack', 'images/slide_button_selector_attack.png');

        // Panels
        this.load.image('game_panel_main_menu', 'images/game_panel_main_menu.png');
        this.load.image('game_panel_about', 'images/game_panel_about.png');
        this.load.image('game_panel_main_big_01', 'images/game_panel_main_big_01.png');
        this.load.image('game_panel_main_big_02', 'images/game_panel_main_big_02.png');
        this.load.image('game_panel_main_medium_01', 'images/game_panel_main_medium_01.png');
        this.load.image('game_panel_main_medium_02', 'images/game_panel_main_medium_02.png');
        this.load.image('game_panel_info_small', 'images/game_panel_info_small.png');
        
        this.load.image('gui_bottom_panel_light_02', './images/gui_bottom_panel_light_02.png');
        this.load.image(
            'gui_bottom_panel_medium',
            globals.gameMode === 'mobile' ? './images/gui_bottom_panel_medium.png' : './images/gui_bottom_panel_medium_desktop.png'
        );

        // Menu
        this.load.image('main_menu_bg', 'images/main_menu_bg.jpg');
        this.load.image('main_menu_logo', 'images/main_menu_logo.png');

        // Game
        this.load.json('levels', 'levels/map_levels_1.json');
        this.load.image('arrow_head', 'images/arrow/arrow_head.png');
        this.load.image('arrow_line', 'images/arrow/arrow_line.png');
        this.load.image('arrow_circle_bg', 'images/arrow/arrow_circle_bg.png');
        this.load.spritesheet('node_type', './images/game_node_type_tileset.png', {frameWidth: 70, frameHeight: 80});
        this.load.spritesheet('movement_villager', './images/game_movement_villager_tileset.png', {frameWidth: 64, frameHeight: 64});
        this.load.image('bg_forest_01', 'images/game_bg_forest_01.png');
        this.load.image('bg_forest_02', 'images/game_bg_forest_02.png');
        this.load.image('bg_forest_03', 'images/game_bg_forest_03.png');
        this.load.image('bg_forest_04', 'images/game_bg_forest_04.png');
        this.load.image('bg_forest_05', 'images/game_bg_forest_05.png');
        this.load.image('bg_arid_01', 'images/game_bg_arid_01.png');
        this.load.image('bg_arid_02', 'images/game_bg_arid_02.png');
        this.load.image('bg_arid_03', 'images/game_bg_arid_03.png');
        this.load.image('bg_arid_04', 'images/game_bg_arid_04.png');
        this.load.image('bg_rock_01', 'images/game_bg_rock_01.png');
        this.load.image('bg_rock_02', 'images/game_bg_rock_02.png');
        this.load.image('bg_rock_03', 'images/game_bg_rock_03.png');

        // Level Selector
        this.load.image('level_selector_bg', 'images/level_selector_bg.jpg');
        this.load.image('level_selector_map_01', 'images/level_selector_map_01.png');
        this.load.image('game_image_info_move_units', 'images/game_image_info_move_units.png');
        this.load.image('game_image_info_town', 'images/game_image_info_town.png');
        this.load.image('game_image_info_castle', 'images/game_image_info_castle.png');
        this.load.image('game_image_info_tower', 'images/game_image_info_tower.png');
        this.load.image('game_image_info_mountain', 'images/game_image_info_mountain.png');
        this.load.image('game_image_info_forest', 'images/game_image_info_forest.png');
        this.load.image('game_image_info_temple', 'images/game_image_info_temple.png');
        this.load.image('game_image_info_hut', 'images/game_image_info_hut.png');
        this.load.image('game_image_info_neutral_town', 'images/game_image_info_neutral_town.png');
        this.load.image('game_image_info_meadows', 'images/game_image_info_meadows.png');
        this.load.image('game_image_info_pause', 'images/game_image_info_pause.png');
        this.load.image('game_image_info_unit_control', 'images/game_image_info_unit_control.png');
        this.load.image('game_image_info_crop', 'images/game_image_info_crop.png');
        this.load.image('game_image_info_farm', 'images/game_image_info_farm.png');
        this.load.image('game_image_info_granary', 'images/game_image_info_granary.png');
        this.load.spritesheet('button_level_selector', './images/button_level_selector.png', {frameWidth: 70, frameHeight: 70});
 
        // Sounds
        this.load.audio('music_lose', 'sounds/music/lose_1.mp3');
        this.load.audio('music_menu', 'sounds/music/menu_1.mp3');
        this.load.audio('music_win', 'sounds/music/win_1.mp3');
        this.load.audio('music_playing', 'sounds/music/playing_1.mp3');
        this.load.audio('music_endgame', 'sounds/music/endgame_1.mp3');
        this.load.audio('click_1', 'sounds/effects/click_1.mp3');
        this.load.audio('click_2', 'sounds/effects/click_2.mp3');

        // End Game
        this.load.image('castle', 'images/endgame_castle.jpg');

        // Loading
        this.createLoading();
    }

    public init(): void {
        super.init();
    }

    public create(): void {
        // Override BaseScene Create to no Resize Camera
    }

    private createLoading(): void {

        // Version
        fetch('./version.json')
            .then(response => response.json())
            .then(data => {
                this.make.text({
                    x: width / 2 - 50,
                    y: height / 2 + 328,
                    text: 'version: ' + data.version,
                    style: {
                        color: '#222', 
                        font: '14px monospace',
                    }
                });
            })
            .catch(error => console.error('Error loading version.json:', error));
        
        // Bg
        const width = this.screenWidth;
        const height = this.screenHeight;
        this.add.image(this.screenWidth / 2, this.screenHeight / 2 - 130, 'preload_bg').setOrigin(0.5, 0.5);

        // Loading Bar
        const progressBox = this.add.graphics();
        const progressBar = this.add.graphics();
        progressBox.fillStyle(0x222222, 0.6);
        progressBox.fillRect(width / 2 - 160, height / 2 + 200, 320, 50);

        const percentText = this.make.text({
            x: width / 2,
            y: height / 2 + 228,
            text: '0%',
            style: {
                font: '18px monospace',
            }
        });
        percentText.setOrigin(0.5, 0.5);

        this.load.on('progress', function (value: number) {
            percentText.setText(Math.round(value * 100) + '%');
            percentText.setOrigin(0.5, 0.5);
            progressBar.clear();
            progressBar.fillStyle(0xde8b2b, 1);
            progressBar.fillRect(width / 2 - 150, height / 2 + 210, 300 * value, 30);
        });

        this.load.on('complete', () => {
            this.time.addEvent({
                delay: globals.debugMode ? 100 : 500,
                callback: () => {
                    progressBar.destroy();
                    progressBox.destroy();
                    percentText.destroy();

                    const startButton = new ButtonSprite(this, this.screenWidth / 2, this.screenHeight / 2 + 225, 'button_preload_start', 2, () => this.startGame());
                    startButton.addText(translate.key('START'));

                    this.onFinishPreload();
                },
                loop: false
            });
        });
    }

    private startGame() {
        if(this.bootloaderScene) {
            this.bootloaderScene.launchScene('MainMenu');
        }
        
    }

    private onFinishPreload() {
        if(this.bootloaderScene) {

            // const configLevel = {
            //     'id': 2,
            //     'image': '',
            //     'bg':'bg_rock_03',
            //     'score': 2,
            //     'globalPopulationSupply' : -1,
            //     'computerStrategy': 'advanced-50',
            //     'players': [
            //         {'id': 'Player', 'type': 'human', 'color': '0xfff00'},
            //         {'id': 'Neutral', 'type': 'neutral', 'color': '0x7c7c7c'},
            //         {'id': 'Computer1', 'type': 'computer', 'color': '0x991717'}
            //     ],
            //     'nodes':[
            //         {'id':'1','x':89,'y':158,'player':'Computer1','options':{'initPopulation':1,'type':'town'}},
            //         {'id':'2','x':191,'y':182,'player':'Neutral','options':{'initPopulation':5,'type':'farm'}},
            //         {'id':'3','x':437,'y':189,'player':'Neutral','options':{'initPopulation':8,'type':'town'}},
            //         {'id':'4','x':352,'y':134,'player':'Neutral','options':{'initPopulation':5,'type':'farm'}},
            //         {'id':'5','x':75,'y':707,'player':'Player','options':{'initPopulation':1,'type':'town'}},
            //         {'id':'6','x':159,'y':754,'player':'Neutral','options':{'initPopulation':5,'type':'town'}},
            //         {'id':'7','x':80,'y':359,'player':'Neutral','options':{'initPopulation':5,'type':'granary'}},
            //         {'id':'8','x':466,'y':577,'player':'Neutral','options':{'initPopulation':5,'type':'granary'}},
            //         {'id':'9','x':475,'y':392,'player':'Neutral','options':{'initPopulation':5,'type':'granary'}},
            //         {'id':'10','x':83,'y':564,'player':'Neutral','options':{'initPopulation':5,'type':'granary'}},
            //         {'id':'11','x':205,'y':292,'player':'Neutral','options':{'initPopulation':5,'type':'forest'}},
            //         {'id':'12','x':353,'y':300,'player':'Player','options':{'initPopulation':5,'type':'forest'}},
            //         {'id':'13','x':213,'y':660,'player':'Neutral','options':{'initPopulation':5,'type':'forest'}},
            //         {'id':'14','x':215,'y':470,'player':'Neutral','options':{'initPopulation':30,'type':'tower'}},
            //         {'id':'15','x':387,'y':726,'player':'Neutral','options':{'initPopulation':8,'type':'temple'}}
            //     ],
            //     'paths':[
            //         {'node1':'10','node2':'8'},
            //         {'node1':'5','node2':'15', 'additionalPoints': [{'x':165, 'y':867}, {'x':400, 'y':867}]},
            //         {'node1':'6','node2':'13'},
            //         {'node1':'5','node2':'13'},
            //         {'node1':'5','node2':'6'},
            //         {'node1':'14','node2':'13'},
            //     ]
            // };
            // this.bootloaderScene.launchScene('GameLevel', configLevel);

            // this.bootloaderScene.launchScene('MainMenu');
            // this.bootloaderScene.launchScene('About');
            // this.bootloaderScene.launchScene('GameWinned');
            // this.bootloaderScene.launchScene('GameLosed');
            // this.bootloaderScene.launchScene('GamePaused');
            // this.bootloaderScene.launchScene('Settings');
            // this.bootloaderScene.launchScene('SettingName');
            // this.bootloaderScene.launchScene('Score');
            // this.bootloaderScene.launchScene('EndGame');
            // this.bootloaderScene.launchScene('LevelSelector');
            
            // this.bootloaderScene.launchScene('GameLevelTest');
            // this.bootloaderScene.launchScene('GameLevelDev');
        }
    }
}